import { render, staticRenderFns } from "./RelatorioSalesOrderView.vue?vue&type=template&id=5e2f5382&scoped=true"
import script from "./RelatorioSalesOrderView.vue?vue&type=script&lang=js"
export * from "./RelatorioSalesOrderView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSalesOrderView.vue?vue&type=style&index=0&id=5e2f5382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f5382",
  null
  
)

export default component.exports